export default "__VITE_ASSET__CpzelGpq__"